module.exports = __webpack_public_path__ + "media/photo/electric_man-2e14e384.png";